import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import NotesContent from "./NotesContent";
import InsuranceDetails from "./InsuranceDetails";
import ServiceHistory from "./ServiceHistory";
import FinesHistory from "./FinesHistory";
import FleetInformationContent from "./FleetInformationContent";
import { FaSave, FaTimes, FaUpload, FaPaperclip } from "react-icons/fa";
import axios from "axios";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import { Snackbar, Alert } from "@mui/material";

const FleetInformation = () => {
  const [value, setValue] = useState(0);
  const [dataFromFleetInfoContent, setDataFromFleetInfoContent] = useState({});
  const [dataFromInsuranceDetails, setDataFromInsuranceDetails] = useState({});
  const [dataFromNotesContent, setDataFromNotesContent] = useState({});
  const [dataFromFineHistory, setDataFromFineHistory] = useState({});
  const [dataFromServiceHistory, setDataFromServiceHistory] = useState({});

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    console.log("dataFromNotesContent:", dataFromNotesContent);
  }, [dataFromNotesContent]);

  useEffect(() => {
    console.log("dataFromInsuranceDetails:", dataFromInsuranceDetails);
  }, [dataFromInsuranceDetails]);

  const [base_url] = useState(base_url_from_axios_config);

  const onSaveFleetInfo = async () => {
    console.log("Fleet info clicked!");

    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    const companyCode = storedUserDataArray[0]?.cmpcode || null;

    const payload = [
      {
        CmpCode: companyCode,
        mode: "ENTRY",
        EmpId: dataFromFleetInfoContent.REG_NO,
        AlternateID: dataFromFleetInfoContent.ENGINE_NO,
        Status: dataFromFleetInfoContent.STATUS,
        Title: dataFromFleetInfoContent.TYPE,
        FistName: dataFromFleetInfoContent.MAKE,
        MiddleName: dataFromFleetInfoContent.MODEL,
        LastName: "",
        DOB: dataFromFleetInfoContent.REG_DATE,
        MaritalStatus: "",
        Gender: "",
        Nationality: "",
        Height: dataFromFleetInfoContent.CHASIS_NO,
        Weight: dataFromFleetInfoContent.PURCH_AMOUNT,
        JoinDate: dataFromInsuranceDetails.START_DATE,
        JobTitle: dataFromInsuranceDetails.COMPANY,
        JobType: dataFromInsuranceDetails.INSUR_TYPE,
        ShiftGroup: "",
        Department: dataFromFleetInfoContent.BRANCH,
        Division: "",
        Grade: "",
        BankAccountNo: dataFromInsuranceDetails.ACC_NO,
        BankName: dataFromInsuranceDetails.SERIAL_NO,
        AgentID: dataFromInsuranceDetails.PREMIUM,
        CurrentAddress: "",
        HomeAddress: "",
        HomeAirport: "",
        WorkMobile: "",
        PersonalMobile: "",
        WorkPhone: "",
        PersonalPhone: "",
        WorkEmail: "",
        PersonalEmail: "",
        PassportNo: "",
        PassportIssueDate: null,
        PassportExpiryDate: null,
        PassportPlaceofIssue: "",
        PassportCountryofIssue: "",
        EmiratesId: "",
        EmiratesIdExpiryDate: null,
        VisaNo: dataFromFleetInfoContent.TRAFFIC_CODE_NO,
        VisaExpiryDate: dataFromFleetInfoContent.EXPIRATION_DATE,
        InsuranceNo: dataFromFleetInfoContent.SALIK_ACC_NO,
        InsuranceExpiryDate: dataFromInsuranceDetails.END_DATE,
        DrivingLicenceNo: "",
        DrivingLicenceExpiryDate: null,
        PersonId: "",
        PersonIdExpiryDate: null,
        BasicPay: 0,
        Allowances_OT: 0.0,
        Allowances_NOT: 0.0,
        NetSalary: 0.0,
        NormalHrs: 0.0,
        HourlyWage: 0.0,
        OTrate: 0,
        SplOtRate: 0,
        photo: "",
        Active: dataFromFleetInfoContent.ACTIVE,
        Memos: dataFromFleetInfoContent.CURR_CUSTODIAN,
        Notes: dataFromNotesContent,
        SalaryAc: "",
        AdvanceAc: "00000000",
        RegOwner: dataFromFleetInfoContent.REG_OWNER,
        SalikPin: dataFromFleetInfoContent.SALIK_PIN,
      },
    ];

    try {
      const apiURL = `${base_url}/api/VehicleInfoReg`;
      const config = { headers: { "Content-Type": "application/json" } };
      const response = await axios.post(apiURL, payload, config);

      const data = response.data;
      console.log("Saved Fleet info:", data);
      setSnackbar({
        open: true,
        message: "Fleet info saved successfully",
        severity: "success",
      });
    } catch (error) {
      console.error("Error While Saving Fleet Info:", error);
    }
    setSnackbar({
      open: true,
      message: "Failed to save fleet info",
      severity: "error",
    });
  };

  return (
    <>
      <div className="flex items-center mb-4">
        <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full mr-2"></div>

        <h6 className="text-xl font-bold text-gray-900">
          <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
            FLEET INFORMATION
          </span>
        </h6>
      </div>
      <div className="flex justify-center items-center gap-8">
        <div className="bg-white w-[16vw] h-[79vh] p-4 border border-gray-200 rounded-lg">
          <div class="group relative  h-[200px] bg-gray-100 rounded-md overflow-hidden shadow-[0_0_0_5px_rgba(255,255,255,0.5)] transition-all duration-700 ease-[cubic-bezier(0.175,0.885,0.32,1.275)] hover:scale-105 hover:shadow-[0_8px_16px_rgba(255,255,255,0.2)] perspective-[1000px]">
            <div class="absolute inset-0 bg-gray-100  border border-gray-100 p-5 flex flex-col justify-center origin-bottom rotate-x-[-90deg] group-hover:rotate-x-0 transition-all duration-700 ease-[cubic-bezier(0.175,0.885,0.32,1.275)]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                class="w-22 h-22 fill-gray-700 transition-all duration-700 group-hover:scale-0"
              >
                <path d="M20 5H4V19L13.2923 9.70649C13.6828 9.31595 14.3159 9.31591 14.7065 9.70641L20 15.0104V5ZM2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11Z" />
              </svg>
            </div>
          </div>

          <div className="flex gap-4  flex-col mt-6">
            {/* Save */}
            <button
              onClick={onSaveFleetInfo}
              className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium bg-green-500 text-white rounded-md hover:bg-green-600 transition"
            >
              <FaSave />
              Save
            </button>

            {/* Close */}
            <button className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium bg-gray-500 text-white rounded-md hover:bg-gray-600 transition">
              <FaTimes />
              Close
            </button>

            {/* Upload */}
            <button className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium bg-blue-500 text-white rounded-md hover:bg-blue-600 transition">
              <FaUpload />
              Upload
            </button>

            {/* Attachment */}
            <button className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium bg-purple-500 text-white rounded-md hover:bg-purple-600 transition">
              <FaPaperclip />
              Attachment
            </button>
          </div>
        </div>
        <div className="bg-white w-[84vw] h-[79vh]   p-4 border border-gray-200 rounded-lg">
          <div className=" h-full w-full flex justify-left ">
            <div className="w-full">
              <Tabs
                value={value}
                onChange={handleChange}
                sx={{
                  "& .MuiTab-root": {
                    fontFamily: "inherit",
                    // textTransform: "none", // optional (removes uppercase)
                    fontWeight: 600,
                  },
                }}
              >
                <Tab label="Fleet Information" />
                <Tab label="Insurance Details" />
                <Tab label="Service History" />
                <Tab label="Fines History" />
                <Tab label="Notes" />
              </Tabs>
             <div className="mt-6 flex-1 overflow-auto">
  <div className={value !== 0 ? "hidden" : ""}>
    <FleetInformationContent
      value={dataFromFleetInfoContent}
      onChange={setDataFromFleetInfoContent}
    />
  </div>

  <div className={value !== 1 ? "hidden" : ""}>
    <InsuranceDetails
      value={dataFromInsuranceDetails}
      onChange={setDataFromInsuranceDetails}
    />
  </div>

  <div className={value !== 2 ? "hidden" : ""}>
    <ServiceHistory
      value={dataFromServiceHistory}
      onChange={setDataFromServiceHistory}
    />
  </div>

  <div className={value !== 3 ? "hidden" : ""}>
    <FinesHistory
      value={dataFromFineHistory}
      onChange={setDataFromFineHistory}
    />
  </div>

  <div className={value !== 4 ? "hidden" : ""}>
    <NotesContent
      value={dataFromNotesContent}
      onChange={setDataFromNotesContent}
    />
  </div>
</div>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default FleetInformation;
